export default __webpack_public_path__ + "static/media/maze1.37de8027.png";